import { request, urlencode } from "./api/index";
import cropr from "../shared/utils/cropr";

export default class APIClient {
  static getURL(path, payload) {
    return `${(payload && payload.cloudfarm_domain) || cropr.cloudfarm_domain || ""}${path}`;
  }

  static async get(path, payload, accessToken) {
    let url = APIClient.getURL(path, payload);
    if (payload) {
      url = `${url}?format=json&${urlencode(payload)}`;
    }

    return await request("GET", url, null, accessToken);
  }

  static async post(path, payload, accessToken) {
    return await request("POST", APIClient.getURL(path, payload), payload, accessToken);
  }

  static async put(path, payload, accessToken) {
    return await request("PUT", APIClient.getURL(path, payload), payload, accessToken);
  }

  static async remove(path, payload, accessToken) {
    return await request("DELETE", APIClient.getURL(path, payload), payload, accessToken);
  }
}
